import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "react-app-polyfill/stable";
import "core-js";
import { Buffer } from "buffer";
import React from "react";
// Ensure `process` exists in the browser to avoid ReferenceError when
// some modules reference `process.env` at runtime.
if (typeof window !== "undefined" && typeof process === "undefined") {
  window.process = {
    env: {},
    nextTick: (fn, ...args) => setTimeout(() => fn(...args), 0),
  };
}
// Polyfill global `Buffer` (requerido por librerías como mammoth para
// previsualizar .docx en el navegador; webpack 5 no lo incluye por defecto).
if (typeof window !== "undefined" && !window.Buffer) {
  window.Buffer = Buffer;
}
import { UserProvider } from "./context/context";
import { PlanillasDownloadProvider } from "./context/PlanillasDownloadContext";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import "react-toastify/dist/ReactToastify.css";
import "./app.css";

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <UserProvider>
        <PlanillasDownloadProvider>
          <App />
        </PlanillasDownloadProvider>
      </UserProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
